import React, { useState } from "react";
import { Lightning } from "@phosphor-icons/react";
import { api, formatApiError } from "@/lib/api";

const IVA = 1.21;

/* Botón de recarga exprés: cobra el importe exacto (5 · 14 · 24 · 44 créditos) y vuelve a `nextPath` tras el pago. */
export default function QuickRechargeButton({ amount, nextPath, label, className = "btn-gold", beforeRedirect, onError, testId = "quick-recharge-btn" }) {
    const [busy, setBusy] = useState(false);
    const total = (amount * IVA).toFixed(2).replace(".", ",");

    async function go(e) {
        e?.preventDefault?.();
        setBusy(true);
        try {
            if (beforeRedirect) beforeRedirect();
            const { data } = await api.post("/payments/checkout", {
                plan_id: "recarga_rapida",
                custom_amount: amount,
                origin_url: window.location.origin,
                next_path: nextPath || window.location.pathname,
            });
            window.location.href = data.url;
        } catch (err) {
            setBusy(false);
            const msg = formatApiError(err, "No se pudo iniciar la recarga rápida");
            if (onError) onError(msg); else alert(msg);
        }
    }

    return (
        <button type="button" onClick={go} disabled={busy} className={`${className} disabled:opacity-60`} data-testid={testId}>
            <Lightning size={14} weight="fill" /> {busy ? "Abriendo pago seguro…" : (label || `Recargar ${amount} créditos · ${total} € IVA incl.`)}
        </button>
    );
}
